import request from "../../utiles/axios";

/**
 * 查询租户列表
 * @param {*} data
 * @returns
 */
export function getTenanpageList(data) {
    return request({
      url: "/company/pageList",
      method: "post",
      data: data,
    });
  }
  /**
 * 修改租户状态
 * @param {*} compCode 
 * @returns
 */
export function changeEnable(compCode) {
    return request({
      url: "/company/enable?compCode=" + compCode ,
      method: "get",
    });
  }
  /**
 * 修改租户信息
 * @param {*} data
 * @returns
 */
export function updateCompanyInfo(data) {
    return request({
      url: "/company/update",
      method: "post",
      data: data,
    });
  }
    /**
 * 添加租户信息
 * @param {*} data
 * @returns
 */
export function addCompanyInfo(data) {
    return request({
      url: "/company/add",
      method: "post",
      data: data,
    });
  }

  export function resetPassword(compCode) {
    return request({
      url: "/company/resetPassword?compCode=" + compCode ,
      method: "get",
    });
  }
  /**
   * 查询租户配置
   */
  export function getCompanyOption(compCode) {
    return request({
      // url: "/companyOption/getCompanyOption?compCode=" + compCode ,
      url: `/companyOption/getCompanyOption/${compCode}`,
      method: "get",
    });
  }
 
  /**
   * 修改租户配置
   */
  export function updateCompanyOption(data) {
    return request({
      url: "/companyOption/updateCompanyOption",
      method: "post",
      data: data,
    });
  }

   /**
   * 新增租户配置
   */

   export function addCompanyOption(data) {
    return request({
      url: "/companyOption/addCompanyOption",
      method: "post",
      data: data,
    });
  }